export default "__VITE_ASSET__CoYKreki__"